export default __webpack_public_path__ + "static/media/NewiPhone.a8b8928d.png";